import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
    template: '#add-to-porter-field-template'
})
export default class AddToPorterFieldComponent extends Vue {
    @Prop()
    productId: string;
    @Prop()
    variantId: string;
    @Prop()
    unitOfMeasure: string;

    created() {
        
        
        // Wolfie... spin that shit
    }
}

Vue.component('add-to-porter-field', AddToPorterFieldComponent); 